import React from "react";
import { useStopwatchController } from "../../controllers/useStopwatchController";
import { StopwatchView } from "./StopwatchView";

interface StopwatchProps {
  onStart?: () => void;
}

export const Stopwatch: React.FC<StopwatchProps> = ({ onStart }) => {
  const controller = useStopwatchController({ onStart });

  return (
    <StopwatchView
      seconds={controller.seconds}
      isRunning={controller.isRunning}
      hasPausedSession={controller.hasPausedSession}
      isPreviousDaySession={controller.isPreviousDaySession}
      canStart={controller.canStart}
      warning={controller.warning}
      filteredCategoryOptions={controller.filteredCategoryOptions}
      categoriesLoading={controller.categoriesLoading}
      onCategorySearchChange={controller.setCategorySearch}
      projectSelection={controller.projectSelection}
      primaryAction={controller.primaryAction}
      onSave={controller.saveSession}
      onReset={controller.resetStopwatch}
      isConfirmingPreviousDay={controller.isConfirmingPreviousDay}
      formattedSessionDate={controller.formattedSessionDate}
      onCloseConfirm={controller.handleCloseConfirm}
      onSavePreviousDay={controller.handleSavePreviousDay}
      onResetPreviousDay={controller.handleResetPreviousDay}
    />
  );
};
